import React from "react";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Link, useNavigate } from "react-router-dom";
import { BreadcrumbComponentProps } from "./breadcrumb-component-props";
import "./breadcrumb-component.scss";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import { Box, IconButton } from "@mui/material";

const BreadcrumbComponent: React.FC<BreadcrumbComponentProps> = ({
  /**
   * BreadcrumbComponent displays a clickable breadcrumb trail.
   * Supports an optional back arrow with custom or history(-1) behavior.
   */
  breadcrumbLink,
  showBackArrow = false,
  handleBackArrowClick,
}) => {
  const navigate = useNavigate();

  return (
    <div className={`breadcrumb-component`}>
      <Box className={`breadcrumb-wrapper`}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {showBackArrow && (
            <IconButton
              onClick={() => {
                if (handleBackArrowClick) {
                  handleBackArrowClick();
                } else {
                  navigate(-1);
                }
              }}
              className="breadcrumb-back-arrow"
              aria-label="Go Back"
            >
              <ArrowBackOutlinedIcon />
            </IconButton>
          )}

          <Stack spacing={2}>
            <Breadcrumbs
              separator={<NavigateNextIcon fontSize="small" />}
              aria-label="breadcrumb"
            >
              {breadcrumbLink?.map((linkData: any, index: any) => {
                const isLast = index === breadcrumbLink.length - 1;

                if (isLast) {
                  return (
                    <Typography key={index + 1} sx={{ color: "text.primary" }}>
                      {linkData?.label}
                    </Typography>
                  );
                }

                if (linkData?.handleClick) {
                  return (
                    <button
                      key={index + 1}
                      className="breadcrumb-link"
                      onClick={linkData.handleClick}
                    >
                      {linkData.label}
                    </button>
                  );
                }
                if (linkData?.link) {
                  return (
                    <Link
                      key={index + 1}
                      to={linkData.link}
                      className="breadcrumb-link"
                    >
                      {linkData.label}
                    </Link>
                  );
                }

                return (
                  <Typography key={index + 1} sx={{ color: "text.secondary" }}>
                    {linkData.label}
                  </Typography>
                );
              })}
            </Breadcrumbs>
          </Stack>
        </div>
      </Box>
    </div>
  );
};

export default BreadcrumbComponent;
